import { useEffect, useState } from 'react';
import Markdown from '../../../../components/Markdown';
import * as S from './style';
import { UseAudio } from 'Hooks';
import { useSiteSettings } from 'context/site-settings';

const OptionButton = ({
  index,
  option,
  isCorrect,
  handleClick,
  selected,
  imageUrl,
  audioUrl,
  grid,
  bubble,
  mb,
  variant,
  find,
  optionsHaveImages,
}) => {
  const { isTpdCourse } = useSiteSettings();
  const { isLoading, fallbackDisabled, handleAudioClick } = UseAudio({
    audioUrl,
    handleClick: () => handleClick({ option, id: index, isCorrect }),
    ...(isTpdCourse ? {} : { fallbackText: option.replace(/\*/g, '') }),
  });
  const [isWideImage, setIsWideImage] = useState(false);

  const audioDisabled = isTpdCourse ? isLoading : isLoading || fallbackDisabled;

  useEffect(() => {
    if (imageUrl) {
      const img = new Image();
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        setIsWideImage(aspectRatio > 2); // threshold for wide images
      };
      img.src = imageUrl;
    }
  }, [imageUrl]);

  return (
    <S.Option
      grid={imageUrl ? !isWideImage && grid : grid}
      onClick={handleAudioClick}
      index={index}
      selected={selected.option + selected.id}
      option={option + index}
      imageUrl={imageUrl}
      mb={mb}
      variant={variant}
      find={find}
      leftPadding={imageUrl ? true : false}
      disabled={audioUrl && audioDisabled}
      optionsHaveImages={optionsHaveImages}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={option}
          style={{
            width: '100%',
            height: '100%',
            objectFit: optionsHaveImages ? 'contain' : 'cover',
          }}
        />
      ) : (
        <Markdown
          text={option}
          customStyles={{
            p: {
              size: bubble ? 'medLarge' : 'med',
              ta: 'center',
              color:
                selected?.option && selected.option === option
                  ? 'neutralSurface'
                  : '',
            },
          }}
        />
      )}
    </S.Option>
  );
};

export default OptionButton;
